import { useEffect } from "react";
import { useState, useRef } from "react";
import { endPoints } from "../../../config/end-points";
import useHttp from "../../../hooks/use-http";

import { cuteToast } from "../../UI/cute";
import Input from "../../UI/Input";

const ForgotPassword = () => {
  const [email, setEmail] = useState();
  const [isValid, setIsvalid] = useState(null);
  const emailRef = useRef();

  const {
    error,
    setError,
    status: httpStatusCode,
    sendRequest: forgotPasswordRequest,
  } = useHttp();

  const emailChange = (event) => {
    if (event.target.value.trim().length > 0) {
      setEmail(event.target.value.trim());
      setIsvalid(true);
    } else {
      setIsvalid(false);
    }
  };

  const responseData = (response) => {
    cuteToast({
      type: "success",
      message: response.message,
      timer: 5000,
      title: "",
    });
    // history.push("/login");
  };
  const handleSubmit = (event) => {
    event.preventDefault();

    if (isValid) {
      forgotPasswordRequest(
        {
          url: endPoints.forgot_password,
          method: "POST",
          headers: {
            "access-control-allow-origin": "*",
            "Content-Type": "application/json",
          },
          body: { email },
        },
        responseData
      );
    } else {
      emailRef.current.focus();
    }
  };

  useEffect(() => {
    if (error && httpStatusCode) {
      cuteToast({
        type: "error",
        message: error,
        timer: 5000,
        title: "",
      });

      setError(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);
  return (
    <form onSubmit={handleSubmit}>
      <h1>Forgot Password</h1>

      <span>
        Please enter your email address below and we will send you information
        to change your password.
      </span>

      <Input
        ref={emailRef}
        type="email"
        placeholder="Enter Your Email Address"
        onChange={emailChange}
        inputClass={`${isValid === false ? "invalid" : ""} rounded`}
      />

      <button>Reset</button>
    </form>
  );
};

export default ForgotPassword;
